module.exports = __webpack_public_path__ + "images/search-67f22f2355628c89ce6f555362aecb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pickles/search.png
// module id = 6h59
// module chunks = 0